import React, { useContext } from "react";
import styled from "styled-components";
import globalContext from "../../Hooks/globalContext";
import DefaultButton from "../Common/DefaultButton";

const Header = styled.div`
  height: 90px;
  padding: 0px 25px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
`;

const Title = styled.div`
  font-size: 24px;
  color: ${(props) => props.theme.black};
`;

const SubTitle = styled.div`
  margin-top: 10px;
  font-size: 16px;
  color: ${(props) => props.theme.darkGrey};
`;

const ButtonWrapper = styled.div`
  position: absolute;
  right: 25px;
`;

const titleFactory = (page, language) => {
  switch (page) {
    case "userList":
      return {
        title: "유저 목록",
        subTitle: "유저를 관리합니다.",
      };
    case "lockupList":
      return {
        title: "락업 로그",
        subTitle: "락업 관련 로그를 조회합니다.",
      };
    case "stakingList":
      return {
        title: "스테이킹 로그",
        subTitle: "스테이킹 관련 로그를 조회합니다.",
      };
    case "mallList":
      return {
        title: "마켓 관리",
        subTitle: "쇼핑몰 관련 메뉴입니다.",
      };
    case "mallOrder":
      return {
        title: "마켓 주문 관리",
        subTitle: "쇼핑몰 주문을 관리합니다.",
      };
    case "registerProduct":
      return {
        title: "마켓 관리 (상품 등록)",
        subTitle: "쇼핑몰 관련 메뉴입니다.",
      };
    case "excelLockup":
      return {
        title: "엑셀 락업",
        subTitle: "엑셀파일을 업로드하여 한번에 락업합니다.",
      };
    case "config":
      return {
        title: "설정",
        subTitle: "월렛 기본 설정을 조정합니다.",
      };
  }
};

const ButtonFactory = ({ page, setPage }) => {
  const mallListOnClick = () => {
    setPage("registerProduct");
  };

  return (
    <>
      {page === "mallList" && (
        <ButtonWrapper onClick={mallListOnClick}>
          <DefaultButton text="상품 등록" />
        </ButtonWrapper>
      )}
    </>
  );
};

const AdminHeader = ({ page, setPage }) => {
  const { language } = useContext(globalContext);
  const info = titleFactory(page, language);

  return (
    <Header>
      <Title>{info.title}</Title>
      <SubTitle>{info.subTitle}</SubTitle>
      <ButtonFactory page={page} setPage={setPage} />
    </Header>
  );
};

export default AdminHeader;
